import { api } from 'data/api/api'

import { BusinessAccountsTermsOfUseResp } from '../types/terms-content'

export const getBusinessAccountsTermsOfUseContent = () =>
  api.get<BusinessAccountsTermsOfUseResp>('/pro_terms_of_use')

export const getPrivateBetaTermsOfUseContent = () =>
  api.get<BusinessAccountsTermsOfUseResp>('/private_beta_terms_of_use')

export const getProTermsAndConditionsContent = () =>
  api.get<BusinessAccountsTermsOfUseResp>('/pro_terms_and_conditions')
